document.addEventListener('DOMContentLoaded', () => {
  // youtube video player
  const playerVars = {
    autoplay: 1,
    rel: 0,
    showinfo: 0,
    ecver: 2,
  };
  const $videoPlayerContainer = document.querySelector('.x-company-introduce__video-container');
  const $videoCloseBtn = document.querySelector('.x-company-introduce__video-close');
  const $videoPlayBtn = document.querySelector('.x-company-introduce__video-play');
  const videoId = $videoPlayBtn.getAttribute('data-video-id');
  const youtubeSrc = `https://www.youtube.com/embed/${videoId}?`;
  const $header = document.querySelector('.x-header');
  const VIDEO_LAYER_SHOW_CLASS = 'x-company-introduce__video-layer--show';
  const HIDE_HEADER_CLASS = 'x-header--hide';
  // save header hidden or not, use for condition to reset header state after video close
  // false: header need to show, true: do nothing
  let isHeaderEverHidden = false;
  // open click event handle
  $videoPlayBtn.addEventListener('click', () => {
    // create iframe player
    const iframe = document.createElement('iframe');
    iframe.src = youtubeSrc + new URLSearchParams(playerVars).toString();
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    // display player
    xUtils.showMask();
    isHeaderEverHidden = $header.classList.contains(HIDE_HEADER_CLASS);
    $header.classList.add(HIDE_HEADER_CLASS);
    $videoPlayerContainer.parentNode.classList.add(VIDEO_LAYER_SHOW_CLASS);
    $videoPlayerContainer.innerHTML = ''; // 清空之前的视频
    $videoPlayerContainer.appendChild(iframe);
  });
  // close click event handle
  $videoCloseBtn.addEventListener('click', () => {
    xUtils.hideMask();
    if (!isHeaderEverHidden) {
      $header.classList.remove(HIDE_HEADER_CLASS);
    }
    $videoPlayerContainer.parentNode.classList.remove(VIDEO_LAYER_SHOW_CLASS);
    $videoPlayerContainer.innerHTML = '';
  });
});
